// helpers/validation.js
export const validateField = (name, value, t, signupDetails, userType = "seeker", accountType = null) => {
  let error = "";
  const firstNameFields = ["first_name", "firstname"];
  const lastNameFields = ["last_name", "name"];

  switch (true) {
    case firstNameFields.includes(name):
      if (!value) {
        error = t("validation.required");
      }
      break;

    case lastNameFields.includes(name):
      if (!value) {
        error = t("validation.required");
      }
      break;

    case name === "social_reason":
      // Only validate if the field should be required
      const shouldBeRequired = 
        userType === "provider" || // Providers are always company
        (userType === "seeker" && accountType === "company"); // Seekers with company account
      
      if (shouldBeRequired && !value) {
        error = t("validation.required");
      }
      // For individual seekers, no validation error even if empty
      break;

    case name === "phone":
      if (!value) {
        error = t("validation.required");
      } else {
        const phoneNumberOnly = value.replace(/^\+\d+\s/, '');
        
        if (!phoneNumberOnly) {
          error = t("validation.required");
        } else if (!/^\d+$/.test(phoneNumberOnly)) {
          error = t("validation.validNumber");
        } else {
          if (phoneNumberOnly.length < 6) {
            error = t("validation.phone.tooShort");
          }
          if (phoneNumberOnly.length > 15) {
            error = t("validation.phone.tooLong");
          }
        }
      }
      break;

    case name === "email":
      if (!value) {
        error = t("validation.required");
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        error = t("validation.email");
      }
      break;

    case name === "password":
      if (!value) {
        error = t("validation.required");
      } else if (value.length < 8) {
        error = t("validation.passwordFormat");
      } else if (!/[a-zA-Z]/.test(value) || !/\d/.test(value)) {
        error = t("validation.passwordFormat");
      }
      break;

    case name === "password_confirmation":
      if (!value) {
        error = t("validation.required");
      } else if (value !== signupDetails?.password) {
        error = t("validation.equalValues");
      }
      break;
      
    default:
      break;
  }
  return error;
};

export const validateRequestQuoteFields = (name, value, t, signupDetails) => {
  let error = "";
  // Fields that share the same validation logic
  const firstNameFields = ["first_name", "firstname"];
  const lastNameFields = ["last_name", "name"];

  switch (true) {
    case firstNameFields.includes(name):
      if (!value) {
        error = t("validation.required");
      }
      break;

    case lastNameFields.includes(name):
      if (!value) {
        error = t("validation.required");
      }
      break;

    case name === "social_reason":
      if (signupDetails?.status === "company" && !value) {
        error = t("validation.required");
      }
      break;

    case name === "phone":
      if (!value) {
        error = t("validation.required");
      }
      break;

    case name === "email":
      if (!value) {
        error = t("validation.required");
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        error = t("validation.email");
      }
      break;

    case name === "password":
      if (!value) {
        error = t("validation.required");
      } else if (value.length < 8) {
        error = t("validation.passwordFormat");
      } else if (!/[a-zA-Z]/.test(value) || !/\d/.test(value)) {
        error = t("validation.passwordFormat");
      }
      break;

    case name === "password_confirmation":
      if (!value) {
        error = t("validation.required");
      } else if (value !== signupDetails?.password) {
        error = t("validation.equalValues");
      }
      break;
      
    case name === "start_event" || name === "end_event":
      if (!value) {
        error = t("validation.required");
      } else if (isNaN(new Date(value).getTime())) {
        error = t("validation.validDate");
      }
      break;

    default:
      break;
  }
  return error;
};

export const validateEditUserDataFields = (name, value, t, inputValues) => {
  let error = "";

  const isEmpty = (val) => !val || val.trim() === "";
  const firstNameFields = ["first_name", "firstname"];
  const lastNameFields = ["last_name", "name"];
const requiredPhoneFields = ["phone", "contact_phone"];
const optionalPhoneFields = ["second_contact_phone"];

  if (firstNameFields.includes(name)) {
    if (isEmpty(value)) {
      error = t("validation.required");
    }
  } else if (lastNameFields.includes(name)) {
    if (isEmpty(value)) {
      error = t("validation.required");
    }
 } else if (requiredPhoneFields.includes(name)) {
    const cleanValue = value.replace(/[\s\-\(\)\.]/g, '');
    
    if (!cleanValue) {
      error = t("validation.required");
    } else if (!/^\+?[0-9]{7,15}$/.test(cleanValue)) {
      error = t("validation.validNumber");
    }
} else if (optionalPhoneFields.includes(name)) {
    // Only validate if value is provided (optional field)
    if (value && value.trim() !== '') {
      const cleanValue = value.replace(/[\s\-\(\)\.]/g, '');
      if (!/^\+?[0-9]{7,15}$/.test(cleanValue)) {
        error = t("validation.validNumber");
      }
    }} else {
    switch (name) {
      // Email fields
      case "new_email":
      case "newSecondEmail":
        if (isEmpty(value)) {
          error = t("validation.required");
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = t("validation.email");
        }
        break;

      case "new_email_confirmation":
        if (isEmpty(value)) {
          error = t("validation.required");
        } else if (value !== inputValues.new_email) {
          error = t("validation.equalValues");
        }
        break;

      case "secondEmailConfirmation":
        if (isEmpty(value)) {
          error = t("validation.required");
        } else if (value !== inputValues.newSecondEmail) {
          error = t("validation.equalValues");
        }
        break;

      // Password fields
      case "currentPassword":
        if (isEmpty(value)) {
          error = t("validation.required");
        } else if (value.length < 8) {
          error = t("validation.passwordFormat");
        }
        break;

      case "new_password":
        if (isEmpty(value)) {
          error = t("validation.required");
        } else if (
          value.length < 8 ||
          !/[a-zA-Z]/.test(value) ||
          !/\d/.test(value)
        ) {
          error = t("validation.passwordFormat");
        }
        break;

      case "new_password_confirmation":
        if (isEmpty(value)) {
          error = t("validation.required");
        } else if (value !== inputValues.new_password) {
          error = t("validation.equalValues");
        }
        break;

      // Company fields
      case "social_reason":
        if (isEmpty(value)) {
          error = t("validation.required");
        }
        break;

      case "company_number":
        if (isEmpty(value)) {
          error = t("validation.required");
        }
        break;

      case "country_of_residence":
        if (isEmpty(value)) {
          error = t("validation.required");
        }
        break;

      case "vat_number":
        if (inputValues?.vat_taxable_person && isEmpty(value)) {
          error = t("validation.required");
        }
        break;

      // Bank details fields
      case "bank_iban":
        if (isEmpty(value)) {
          error = t("validation.required");
        } else {
          const ibanRegex = /^[A-Z0-9]{15,34}$/;
          if (!ibanRegex.test(value.replace(/\s/g, ''))) {
            error = t("validation.formatError");
          }
        }
        break;

      case "bank_bic":
        if (isEmpty(value)) {
          error = t("validation.required");
        } else {
          const bicRegex = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
          if (!bicRegex.test(value)) {
            error = t("validation.formatError");
          }
        }
        break;

      case "bank_owner":
        if (isEmpty(value)) {
          error = t("validation.required");
        } else if (value.trim().length < 3) {
          error = t("validation.formatError");
        }
        break;

      // Optional fields - no validation
      case "position":
      case "function":
      case "second_function":
      case "fax":
      case "contact_fax":
        break;

      // Individual seeker address fields
      case "address":
      case "city":
      case "zipCode":
        break;

      default:
        console.warn(`Unhandled validation field: ${name}`);
        break;
    }
  }

  return error;
};


